const blogcategory = {
    getlist: 'blogcategory/getlist-by-admin',
    add: 'blogcategory/add',
    update: 'blogcategory/update',
    remove: 'blogcategory/remove',
    get: 'blogcategory/get',
    getall: 'blogcategory/getall-by-admin',
    clearcache: 'blogcategory/clear-cache',
    redirectList: 'redirect/getlist',
    removeUrl: 'redirect/remove',
    removeRedirect: 'redirect/remove',
    addRedirect:'redirect/add',
    updateRedirect: 'redirect/update'
}
export default blogcategory
